import { render, staticRenderFns } from "./SendHelpRequest.vue?vue&type=template&id=1a897c58"
import script from "./SendHelpRequest.vue?vue&type=script&lang=js"
export * from "./SendHelpRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports